<template>
    <table v-if="treeData.word">
      <tr v-if="treeData.state > 100000">
        <td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
          <div :class="{node: true, hasMate: treeData.mate}">
            <div style="border:1px solid #000;background:#FFAAFF" class="infom" @click="$emit('click-node', treeData)">
			  <!-- <div class="role">{{treeData.role}}</div> -->
              <!-- <div class="state">{{treeData.state}}</div>-->			  
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
           </div>
          </div>
          <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
        </td>
      <tr v-else-if="treeData.state > 99999">
        <td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
          <div :class="{node: true, hasMate: treeData.mate}">
            <div style="border:1px solid #000;background:#FFEEFF" class="infom" @click="$emit('click-node', treeData)">
			  <!-- <div class="role">{{treeData.role}}</div> -->
              <!-- <div class="state">{{treeData.state}}</div>-->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
			</div>
          </div>
          <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
        </td>
      </tr>
      <tr v-else-if="treeData.state > 9999">
        <td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
          <div :class="{node: true, hasMate: treeData.mate}">
            <div style="border:1px solid #000;background:#FF00FF" class="infom" @click="$emit('click-node', treeData)">
			  <!-- <div class="role">{{treeData.role}}</div> -->
              <!-- <div class="state">{{treeData.state}}</div>-->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
           </div>
          </div>
          <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
        </td>
      </tr>
      <tr v-else-if="treeData.state > 1999">
        <td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
          <div :class="{node: true, hasMate: treeData.mate}">
            <div style="border:1px solid #000;background:#33FFFF" class="infom" @click="$emit('click-node', treeData)">
            <div class="role">{{treeData.role}}</div>
            <!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
          </div>
          </div>
          <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
        </td>
      </tr>
      <tr v-else-if="treeData.state > 999">
        <td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
          <div :class="{node: true, hasMate: treeData.mate}">
            <div style="border:1px solid #000;background:#F0F0F0" class="infom" @click="$emit('click-node', treeData)">
            <!-- <div class="role">{{treeData.role}}</div> -->
            <!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
           </div>
          </div>
          <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
        </td>
      </tr>
      <tr v-else-if="treeData.state > 129">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#FF9900" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
	  <tr v-else-if="treeData.state > 119">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#FF3300" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
	  <tr v-else-if="treeData.state > 109">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#FFCCCC" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
      <tr v-else-if="match_mod(treeData.state) === 0">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#FFFFFF" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
	  <tr v-else-if="match_mod(treeData.state) === 1">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#F0F0F0" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
	  <tr v-else-if="match_mod(treeData.state) === 2">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#AADD00" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
	  <tr v-else-if="match_mod(treeData.state) === 3">
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#CCFF00" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>
	  <tr v-else>
		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" :class="{parentLevel: treeData.children, extend: treeData.children && treeData.extend}">
		  <div :class="{node: true, hasMate: treeData.mate}">
			<div style="border:1px solid #000;background:#FFFFFF" class="infom" @click="$emit('click-node', treeData)">
			<!-- <div class="role">{{treeData.role}}</div> -->
			<!-- <div class="state">{{treeData.state}}</div> -->
             <div class="link" v-if="check_show_link==='true'">{{treeData.link}}</div>
             <div class="relation_count" v-if="check_show_relation_count==='true'">{{treeData.relation_count}}</div>
             <div class="head" v-if="check_show_head==='true'">{{treeData.head}}</div>
             <div class="entity" v-if="check_show_entity==='true'">{{treeData.entity}}</div>
             <div class="sense" v-if="check_show_sense==='true'">{{treeData.sense}}</div>
             <div class="pos" v-if="check_show_pos==='true'">{{treeData.pos}}</div>
             <div class="word" v-if="check_show_word==='true'">{{treeData.word}}</div>
             <div class="number" v-if="check_show_number==='true'">{{treeData.number}}</div>
		   </div>
		  </div>
		  <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
		</td>
	  </tr>		  
      <tr v-if="treeData.children && treeData.extend">
        <td v-for="(children, index) in treeData.children" :key="index" colspan="2" class="childLevel">
          <TreeChart :json="children" @click-node="$emit('click-node', $event)"/>
        </td>
      </tr>
     </table>

</template>

<script>
export default {
  name: "TreeChart",
  props: ["json"],
  data() {
    return {
    check_show_number :true,
    check_show_word :true,
    check_show_pos :true,
    check_show_sense :true,
    check_show_entity :true,
    check_show_head :true,
    check_show_relation_count :true,
    check_show_link :true,
      treeData: {}
    }
  },
  watch: {
    json: {
      handler: function(Props){
	  this.check_show_number = localStorage.getItem("check_show_number");
	  this.check_show_word = localStorage.getItem("check_show_word");
	  this.check_show_pos = localStorage.getItem("check_show_pos");
	  this.check_show_sense = localStorage.getItem("check_show_sense");
	  this.check_show_entity = localStorage.getItem("check_show_entity");
	  this.check_show_head = localStorage.getItem("check_show_head");
	  this.check_show_relation_count = localStorage.getItem("check_show_relation_count");
	  this.check_show_link = localStorage.getItem("check_show_link");
	 
        let extendKey = function(jsonData){
          jsonData.extend = (jsonData.extend===void 0 ? true: !!jsonData.extend);
          if(Array.isArray(jsonData.children)){
            jsonData.children.forEach(c => {
              extendKey(c)
            })
          }
          return jsonData;
        }
        if(Props){
          this.treeData = extendKey(Props);
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleExtend: function(treeData){
      treeData.extend = !treeData.extend;
      this.$forceUpdate();
    },
	match_mod: function(state){
	  return Number(state)%10
	}
  }
}
</script>

<style scoped>
table{border-collapse: separate!important;border-spacing: 0!important;}
td{position: relative; vertical-align: top;padding:0 0 40px 0;text-align: center;}

.extend_handle{position: absolute;left:50%;bottom:20px; width:10px;height: 10px;padding:10px;transform: translate3d(-15px,0,0);cursor: pointer;}
.extend_handle:before{content:""; display: block; width:100%;height: 100%;box-sizing: border-box; border:2px solid;border-color:#a88 #a88 transparent transparent;
transform: rotateZ(135deg);transform-origin: 50% 50% 0;transition: transform ease 300ms;}
.extend_handle:hover:before{border-color:#3aa #3aa transparent transparent;}
.extend .extend_handle:before{transform: rotateZ(-45deg);}

.extend::after{content: "";position: absolute;left:50%;bottom:15px;height:15px;border-left:2px solid #a88;transform: translate3d(-1px,0,0)}
.childLevel::before{content: "";position: absolute;left:50%;bottom:100%;height:15px;border-left:2px solid #a88;transform: translate3d(-1px,0,0)}
.childLevel::after{content: "";position: absolute;left:0;right:0;top:-15px;border-top:2px solid #a88;}
.childLevel:first-child:before, .childLevel:last-child:before{display: none;}
.childLevel:first-child:after{left:50%;height:10px; border:2px solid;border-color:#a88 transparent transparent #a88;border-radius: 6px 0 0 0;transform: translate3d(1px,0,0)}
.childLevel:last-child:after{right:50%;height:10px; border:2px solid;border-color:#a88 #a88 transparent transparent;border-radius: 0 6px 0 0;transform: translate3d(-1px,0,0)}
.childLevel:first-child.childLevel:last-child::after{left:auto;border-radius: 0;border-color:transparent #a88 transparent transparent;transform: translate3d(1px,0,0)}

.node{position: relative; display: inline-block;width: 13em;box-sizing: border-box; text-align: center; border-color:#a88 }
.node .infom{position: relative; display: inline-block;z-index: 2;width:6.5em; overflow: hidden;}
.node .infom .node_attribute{height:1.5em;line-height: 1.2em;overflow: hidden;width:100%;font-weight:bold;}
.node .infom .node_content{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;}
.node .infom .number{height:1.5em;line-height: 1.2em;overflow: hidden;width:100%;font-size:14px;font-weight:bold;}
.node .infom .word{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;font-size:12px;}
.node .infom .pos{height:1.2em;line-height:1.0em;overflow: hidden;width:100%;font-size:12px;}
.node .infom .sense{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;font-size:12px;}
.node .infom .entity{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;font-size:12px;color:blue;}
.node .infom .head{height:1.5em;line-height: 1.2em;overflow: hidden;width:100%;font-size:12px;}
.node .infom .relation_count{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;font-size:10px;color:red;}
.node .infom .link{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;font-size:12px;}
.node .infom .state{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;font-size:12px;}
.node .infom .role{height:1.2em;line-height: 1.0em;overflow: hidden;width:100%;color:red;}

</style>



// WEBPACK FOOTER //
// src/components/TreeChart.vue